import { GoToAccountSettingsCTA } from "./ctas";
export var ManageEoriInfoIA = function ManageEoriInfoIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_EORI_INFORMATION(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_ENTER_YOUR_EORI_NUMBER(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var MANAGE_EORI_INFORMATION = function MANAGE_EORI_INFORMATION(strictLocalize) {
  return strictLocalize({
    id: "uBjxbK",
    defaultMessage: [{
      "type": 0,
      "value": "Gerir informações EORI"
    }]
  });
};
var YOU_CAN_ENTER_YOUR_EORI_NUMBER = function YOU_CAN_ENTER_YOUR_EORI_NUMBER(strictLocalize) {
  return strictLocalize({
    id: "Fvy0Em",
    defaultMessage: [{
      "type": 0,
      "value": "Pode introduzir o seu número EORI na secção \"Informações fiscais e de importação\" no separador O meu perfil da página Definições de conta."
    }]
  });
};